import AsyncStorage from '@react-native-async-storage/async-storage';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

const PRICING_TABLE_UI_STORAGE_KEY = 'pricing_table_ui';

interface PricingTableUIStore {
  hasSeenAgentHelpModal: boolean;
  isQuickActionsOpen: boolean;
  markAgentHelpModalSeen: () => void;
  setQuickActionsOpen: (next: boolean) => void;
}

export const usePricingTableUIStore = create<PricingTableUIStore>()(
  persist(
    (set) => ({
      hasSeenAgentHelpModal: false,
      isQuickActionsOpen: false,
      markAgentHelpModalSeen: () => set({ hasSeenAgentHelpModal: true }),
      setQuickActionsOpen: (next) => set({ isQuickActionsOpen: next }),
    }),
    {
      name: PRICING_TABLE_UI_STORAGE_KEY,
      partialize: (state) => ({
        hasSeenAgentHelpModal: state.hasSeenAgentHelpModal,
      }),
      storage: createJSONStorage(() => AsyncStorage),
    },
  ),
);
